module.exports = __webpack_public_path__ + "0a7a65cab6c5c269cfb244bef50b2d31.jpg";